(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["layered-slideshow"] && !Shopify.designMode) return;
  try {
    
  class LayeredSlideshow extends HTMLElement {
    constructor() {
      super();
      this.container = this.querySelector('[ref="container"]');
      this.tabs = Array.from(this.querySelectorAll('[ref="tabs[]"]'));
      this.panels = Array.from(this.querySelectorAll('.layered-slideshow__panel'));
      this.totalTabs = this.tabs.length;
      this.currentIndex = 0;
      this.autoplayEnabled = this.dataset.autoplay === 'true';
      this.autoplayInterval = parseInt(this.dataset.autoplayInterval) || 5000;
      this.autoplayTimer = null;
      this.isDragging = false;
      this.dragStartX = 0;
      this.dragThreshold = 30;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (this.totalTabs < 2) return;

      this.init();
    }

    init() {
      // Set initial grid template
      this.updateGridTemplate(this.currentIndex);

      // Add event listeners
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', (e) => this.handleTabClick(e, index));
        tab.addEventListener('keydown', (e) => this.handleTabKeydown(e, index));
      });

      // Drag functionality
      this.container.addEventListener('mousedown', (e) => this.handleDragStart(e));
      this.container.addEventListener('touchstart', (e) => this.handleDragStart(e), { passive: true });
      window.addEventListener('mousemove', (e) => this.handleDragMove(e));
      window.addEventListener('touchmove', (e) => this.handleDragMove(e), { passive: false });
      window.addEventListener('mouseup', () => this.handleDragEnd());
      window.addEventListener('touchend', () => this.handleDragEnd());

      // Pause autoplay on hover / focus
      this.container.addEventListener('mouseenter', () => this.pauseAutoplay());
      this.container.addEventListener('focusin', () => this.pauseAutoplay());
      this.container.addEventListener('mouseleave', () => this.resumeAutoplay());
      this.container.addEventListener('focusout', () => this.resumeAutoplay());

      // Start autoplay if enabled and not reduced motion
      if (this.autoplayEnabled && !this.reducedMotion) {
        this.startAutoplay();
      }

      // Listen for reduced motion changes
      window.matchMedia('(prefers-reduced-motion: reduce)').addEventListener('change', (e) => {
        this.reducedMotion = e.matches;
        if (this.reducedMotion) {
          this.pauseAutoplay();
        } else if (this.autoplayEnabled) {
          this.startAutoplay();
        }
      });

      // Ensure autoplay interval is not blocked by any stuck state
      this.addEventListener('slidechange', () => {
        if (this.autoplayEnabled && !this.reducedMotion && !this.isDragging) {
          this.resumeAutoplay();
        }
      });
    }

    updateGridTemplate(index) {
      const activeTabWidth = 'minmax(0, 1fr)';
      const inactiveTabWidth = 'var(--button-width)';
      let gridTemplate = '';

      for (let i = 0; i < this.totalTabs; i++) {
        if (i === index) {
          gridTemplate += activeTabWidth;
        } else {
          gridTemplate += inactiveTabWidth;
        }
        if (i < this.totalTabs - 1) gridTemplate += ' ';
      }

      this.container.style.setProperty('--active-tab', gridTemplate);
      this.container.style.setProperty('--active-index', index);

      // Update ARIA and inert states
      this.tabs.forEach((tab, i) => {
        const selected = i === index;
        tab.setAttribute('aria-selected', selected);
        tab.tabIndex = selected ? 0 : -1;
      });

      this.panels.forEach((panel, i) => {
        if (i === index) {
          panel.removeAttribute('inert');
        } else {
          panel.setAttribute('inert', '');
        }
      });

      this.currentIndex = index;
      // Dispatch event for any external listeners
      this.dispatchEvent(new CustomEvent('slidechange', { detail: { index } }));
    }

    goToSlide(index) {
      if (index < 0) index = this.totalTabs - 1;
      if (index >= this.totalTabs) index = 0;

      this.updateGridTemplate(index);
    }

    nextSlide() {
      this.goToSlide(this.currentIndex + 1);
    }

    previousSlide() {
      this.goToSlide(this.currentIndex - 1);
    }

    handleTabClick(e, index) {
      e.preventDefault();
      this.goToSlide(index);
      this.pauseAutoplay();
      this.resumeAutoplay(); // restart timer after interaction
    }

    handleTabKeydown(e, index) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.goToSlide(index);
        this.pauseAutoplay();
        this.resumeAutoplay();
      }
    }

    handleDragStart(e) {
      if (e.target.closest('button')) return; // ignore if starting on a button

      this.isDragging = true;
      this.container.setAttribute('data-dragging', '');
      this.pauseAutoplay();

      const clientX = e.type.startsWith('touch') ? e.touches[0].clientX : e.clientX;
      this.dragStartX = clientX;

      // Prevent default on touchmove to stop scrolling while dragging
      if (e.type === 'touchstart') {
        e.preventDefault();
      }
    }

    handleDragMove(e) {
      if (!this.isDragging) return;

      const clientX = e.type.startsWith('touch') ? e.touches[0].clientX : e.clientX;
      const deltaX = clientX - this.dragStartX;

      if (Math.abs(deltaX) > this.dragThreshold) {
        if (deltaX > 0) {
          this.previousSlide();
        } else {
          this.nextSlide();
        }
        this.handleDragEnd();
      }

      // Prevent page scroll when dragging horizontally on touch devices
      if (e.cancelable && e.type === 'touchmove') {
        e.preventDefault();
      }
    }

    handleDragEnd() {
      if (this.isDragging) {
        this.isDragging = false;
        this.container.removeAttribute('data-dragging');
        this.resumeAutoplay();
      }
    }

    startAutoplay() {
      if (this.autoplayTimer) clearInterval(this.autoplayTimer);
      this.autoplayTimer = setInterval(() => {
        // Only advance if not dragging and reduced motion not active
        if (!this.isDragging && !this.reducedMotion && this.autoplayEnabled) {
          this.nextSlide();
        }
      }, this.autoplayInterval);
    }

    pauseAutoplay() {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }

    resumeAutoplay() {
      if (this.autoplayEnabled && !this.reducedMotion && !this.isDragging) {
        this.startAutoplay();
      }
    }

    disconnectedCallback() {
      this.pauseAutoplay();
    }
  }

  customElements.define('layered-slideshow-component', LayeredSlideshow);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
